import React, { useState } from "react";

import styles from "./styles/Courses.module.scss";

import { Col, Row, Spinner } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { SubTitle } from "../../Components/CustomComponents";
import { WEB_ROUTES } from "../../constants";
import CourseComponent from "./CourseComponent";
import { useEnrollTrainingMutation, useGetTrainingByCategoryIdQuery } from "../../Data/services/trainingApi";
import EmptyContainer from "../../Components/Container/EmptyContainer";
import _ from "lodash";
import Toast, { SuccessToast } from "../../Hooks/useToast";

export default function Courses({ setPage }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { item } = location.state || {};
  
   const [enrollingId, setEnrollingId] = useState(undefined);

  // console.log(item);
  const { data, isLoading: traningLoading, error, refetch } = useGetTrainingByCategoryIdQuery(item?.id,{
    refetchOnMountOrArgChange: true,
  });
  console.log(data);

  const [enrollTraining, { isError, isLoading: enrollLoading, isSuccess }] =
    useEnrollTrainingMutation();

  const handleEnroll = async (triningId) => {
    setEnrollingId(triningId);
    const data = {
      training_id: triningId,
    };

    try {
      const response = await enrollTraining(data);

      // console.log(response.error.status);
      console.log(response);

      if (response.error && response.error.status >= 400) {
        const message = await response.error.data.message;
        Toast(`${message}`, "error");
        // console.log(message)
      }

      if (!response.error && response.data.code === 200) {
        refetch();
        SuccessToast(response?.data?.message);
      }
    } catch (error) {
      console.log(error);
      if (error?.response && error?.response?.data?.message) {
        Toast(error?.response?.data?.message, "error");
      } else {
        Toast("An error occurred during login", "error");
      }
    } finally {
      setEnrollingId(undefined);
    }
  };

  const handleBackButtonClck = () => {
    setPage(WEB_ROUTES.ALL_CATEGORIES);
  };

  return (
    <div className={styles.Courses}>
      <div className={styles.headerContainer}>
        <SubTitle text={item?.name} />
      </div>
      <Row>
        {traningLoading ? (
          <EmptyContainer text={<Spinner size="lg" />} classes="my-2" />
        ) : _.isEmpty(data?.data) || error ? (
          <EmptyContainer text="Data Not Found" classes="my-2" />
        ) : (
          (data?.data || [])?.map((item, index) => {
            return (
              <Col md="6" xl="4" className="my-2" key={index}>
                <CourseComponent
                  key={index}
                  // image={`/images/Orthopaedics.png`}
                  image={item.image_url}
                  title={item.name}
                  description={item.description}
                  enrollStatus={item.is_enrolled}
                  trainingId={item.id}
                  handleEnroll={handleEnroll}
                  isEnrolling={enrollLoading && enrollingId == item.id}
                  onSelect={(e) => {
                    console.log(item.id);
                    // console.log(index);
                    navigate(`/${WEB_ROUTES.BATCHES}`, {
                      state: {
                        item: {
                          id: item.id,
                          title: item.name,
                          image_url: item.image_url,
                          is_enrolled: item.is_enrolled,
                        },
                      },
                    });
                  }}
                />
              </Col>
            );
          })
        )}
      </Row>
    </div>
  );
}
